export default __webpack_public_path__ + "static/rust-1dca81dc42708811d839c46ffc53d824.png";